module.exports = __webpack_public_path__ + "img/bg-header.246bb24e.jpg";